export var THUMBNAIL_SPACING_PRESETS;
(function (THUMBNAIL_SPACING_PRESETS) {
    THUMBNAIL_SPACING_PRESETS["NONE"] = "NONE";
    THUMBNAIL_SPACING_PRESETS["NARROW"] = "NARROW";
    THUMBNAIL_SPACING_PRESETS["WIDE"] = "WIDE";
})(THUMBNAIL_SPACING_PRESETS || (THUMBNAIL_SPACING_PRESETS = {}));
export const THUMBNAIL_SPACING_VALUE_PER_PRESET = {
    [THUMBNAIL_SPACING_PRESETS.NONE]: 0,
    [THUMBNAIL_SPACING_PRESETS.NARROW]: 24,
    [THUMBNAIL_SPACING_PRESETS.WIDE]: 52,
};
//# sourceMappingURL=thumbnail-spacing-presets.js.map